import { render, staticRenderFns } from "./ListaTransaction.vue?vue&type=template&id=4d5c6fc4"
import script from "./ListaTransaction.vue?vue&type=script&lang=js"
export * from "./ListaTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports